import React, {FC} from 'react';
import {COMPONENT_TYPE} from "../../FormNew/RenderInput";


function RenderInputType(props) {
  const {row,value, onChange, onBlur, functionAfterSelect, variables} = props
  const ComponentToShow = COMPONENT_TYPE[row.type];
  return ComponentToShow ? (<ComponentToShow
    //{row, onChange, onBlur, functionAfterSelect, variables}
    {...props}
    onChange={onChange}
  />) : (<input value={"تایپ ورودی در برنامه تعریف نشده!"} disabled={true}/>);
}

export default RenderInputType;


